import { render, staticRenderFns } from "./DiagnosticDropdown.vue?vue&type=template&id=4fb5f7e9"
import script from "./DiagnosticDropdown.vue?vue&type=script&lang=js"
export * from "./DiagnosticDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports